// extracted by mini-css-extract-plugin
export default {"header":"Header_header__mtodi","menu":"Header_menu__ddsbd"};